const END_CONFIRMED_KEY = 'VideoNewApp-notaReportEndConfirmed';

export function markSessionEndConfirmed(): void {
  sessionStorage.setItem(END_CONFIRMED_KEY, 'true');
}

export function consumeSessionEndConfirmed(): boolean {
  const confirmed = sessionStorage.getItem(END_CONFIRMED_KEY) === 'true';
  sessionStorage.removeItem(END_CONFIRMED_KEY);
  return confirmed;
}

export function peekSessionEndConfirmed(): boolean {
  try {
    return sessionStorage.getItem(END_CONFIRMED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function shouldConfirmDoctorSessionEnd(): boolean {
  return process.env.REACT_APP_DISABLE_NOTA_REPORT !== 'true';
}
